
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 70 70","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M57.785 18.2h-3.99v-7.49a.867.867 0 00-.875-.875H15.19a.867.867 0 00-.875.875v7.49h-2.1a.867.867 0 00-.875.875c0 .49.385.875.875.875h2.1v7.49c0 .49.385.875.875.875h37.73c.49 0 .875-.385.875-.875v-7.455h3.08v11.76h-22.96a.867.867 0 00-.875.875v9.87h-2.065a.867.867 0 00-.875.875V59.29c0 .49.385.875.875.875h6.335c.49 0 .875-.385.875-.875V43.4a.867.867 0 00-.875-.875h-2.52v-9.03h22.995c.49 0 .875-.385.875-.875V19.075a.867.867 0 00-.875-.875zm-9.205-3.115H19.53a.867.867 0 01-.875-.875c0-.49.385-.875.875-.875h29.015c.49 0 .875.385.875.875.035.49-.35.875-.84.875zM36.4 44.275v14.14h-4.55v-14.14h4.55z","fill":"#27AE60"}})])
          )
        }
      }
    